import { api } from "./api";

export interface PaymentMethod {
  id: string;
  name: string;
  /** Code métier : CB, ESP, CHQ, TKT, CARTE TKT, VRT */
  code?: string | null;
  isActive: boolean;
  displayOrder: number;
  createdAt: string;
  updatedAt: string;
}

export interface PaymentStatus {
  id: string;
  name: string;
  colorCode: string;
  displayOrder: number;
  createdAt: string;
  updatedAt: string;
}

/**
 * Service pour la gestion des méthodes et statuts de paiement
 */
export const paymentService = {
  /**
   * Récupère toutes les méthodes de paiement actives
   */
  async getAllMethods(): Promise<PaymentMethod[]> {
    const response = await api.get<{ success: boolean; data: PaymentMethod[] }>(
      "/payments/methods",
    );
    return response.data?.data ?? [];
  },

  /**
   * Récupère tous les statuts de paiement
   */
  async getAllStatuses(): Promise<PaymentStatus[]> {
    const response = await api.get<{ success: boolean; data: PaymentStatus[] }>(
      "/payments/statuses",
    );
    return response.data?.data ?? [];
  },
};
